import {useDisclosure } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import AppKeepAlive from "./appKeepAlive";
import AppLayout from ".";
import ModalComponent from "../components/modal";
import CangePassword from "../parts/dashboard/changePassword";
import { useGetPlanInfo } from "../services/planService";

const ProtectedRoute = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { planInfo } = useGetPlanInfo();

  useEffect(() => {
    const firstTym = sessionStorage.getItem("firstTimeLogin");
    const isEnterprise = planInfo?.plan === "enterprise" || planInfo?.plan_name?.toLowerCase().includes("enterprise");

    // Show password change modal for first-time login
    // Enterprise users are required to change password on first login
    // Other users can also change password on first login (backward compatibility)
    if (firstTym === "true") {
      onOpen();
    }
    //eslint-disable-next-line
  }, [planInfo]);

  if (localStorage.getItem("systemRole") === "ess_user") {
    return <Navigate to="/ess" replace />;
  }

  return (
    <>
      <AppKeepAlive>
        <AppLayout />
      </AppKeepAlive>

      <ModalComponent
        isOpen={isOpen}
        onClose={() => false}
        size={"md"}
        title={"Change Your Password"}
        closeBtn={false}
      >
        <CangePassword 
          close={onClose} 
          isEnterprise={planInfo?.plan === "enterprise" || planInfo?.plan_name?.toLowerCase().includes("enterprise")}
        />
      </ModalComponent>
    </>
  );
};

export default ProtectedRoute;
